<ui-feedback-header
  [title]="config.title"
  [state]="config.state"
  [showCloseBtn]="config.dismissible"
  (handleAction)="cancel()"
/>

@if (config.content; as content) {
  <ui-feedback-body
    [uiMaskPii]="!!config.shouldMaskPii"
    [content]="content"
    [contentParams]="config.contentParams"
  />
}

<ui-feedback-footer
  [primaryConfig]="primaryConfig"
  [primaryDataTest]="config.primaryDataTest"
  [secondaryConfig]="secondaryConfig"
  [secondaryDataTest]="config.secondaryDataTest"
  [tertiaryConfig]="tertiaryConfig"
  [tertiaryDataTest]="config.tertiaryDataTest"
  [isLoading]="isLoading"
  (handlePrimaryClick)="confirm()"
  (handleSecondaryClick)="cancel()"
  (handleTertiaryClick)="handleTertiaryClick.emit()"
/>
